import React from "react";
import './ResultsWithIMG.css';
import ContestMenu from "../ContestMenu/ContestMenu";
import SendQuestion from "../../../00LayoutMain/TopMenu/SendQuestion/SendQuestion";
import LayoutMain from "../../../00LayoutMain/LayoutMain";
import QueryContestResultsWithIMGSource from "./QueryContestResultsWithIMGSource/QueryContestResultsWithIMGSource";
import TextChange from "../../../../../AdminPart/src/Elements/TextChange/TextChange";

function GatsbyContestResultsWithIMGSource(props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts02[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts02[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        const MenuTop = [
        {Link : '',Name : props.PrerenderTexts02['ContestResult0000'] ? JSON.parse(props.PrerenderTexts02['ContestResult0000'])[props.lang] : '*Все конкурсы'},
        {Link : '/prizes/',Name : props.PrerenderTexts02['ContestResult0005'] ? JSON.parse(props.PrerenderTexts02['ContestResult0005'])[props.lang] : '*Получить приз'},
    ];
        console.log('GatsbyContestResultsWithIMGSource',props.PrerenderTexts);

    return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} >
            <main className="TraderAllArchive StandartPage">
                <div className="StandartWhitePart">
                    <div className="StandartWhitePartTitle">
                        <div className="StandartWhitePartTitleText">
                            <TextSource ArrIndex= 'ContestResult0020'>Архив результатов конкурсов.</TextSource>
                        </div>
                        <SendQuestion lang={props.lang}/>
                    </div>
                    <ContestMenu lang={props.lang} Menu={MenuTop}/>
                    <QueryContestResultsWithIMGSource lang={props.lang}/>
                </div>
            </main>
        </LayoutMain>

    )}

export default GatsbyContestResultsWithIMGSource